import  allTypes  from "../publicModule/publicMutationTypes"

  const INIT_DATA = "INIT_DATA" // 同步功能
 
 export default {
   ...allTypes,
   INIT_DATA
}
